'use client';
import { TextareaAutosizeProps } from '@mui/base/TextareaAutosize';
import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system/styleFunctionSx';
import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CCTextarea } from '../core/cc-textarea';

type Props = TextareaAutosizeProps & {
  name: string;
  sx?: SxProps<Theme>;
};

export const RHFTextarea = forwardRef<HTMLTextAreaElement, Props>(({ name, sx, ...other }, ref) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CCTextarea
          {...field}
          {...other}
          ref={ref}
          aria-label="minimum height"
          minRows={3}
          style={{ resize: 'none' }}
        />
      )}
    />
  );
});

RHFTextarea.displayName = 'RHFTextarea';
